const texts = {
    "terms-and-conditions-intro": {
        EN: "I agree to the",
        DA: "Jeg accepterer",
        DE: "Ich akzeptiere die",
        NL: "Ik ga akkoord met de",
        FR: "J'accepte les",
        IT: "Accetto i",
        ES: "Acepto los",
        PT: "Eu aceito os",
        FI: "Hyväksyn",
        SV: "Jag accepterar",
        NO: "Jeg aksepterer",
    },
    "terms-and-conditions": {
        EN: "Terms & Conditions",
        DA: "Handelsbetingelser",
        DE: "Geschäftsbedingungen",
        NL: "Voorwaarden",
        FR: "Conditions Générales",
        IT: "Termini e Condizioni",
        ES: "Términos y Condiciones",
        PT: "Termos e Condições",
        FI: "Käyttöehdot",
        SV: "Villkor",
        NO: "Vilkår og betingelser",
    },
    "terms-and-conditions-error": {
        EN: "You must accept the terms & conditions",
        DA: "Du skal acceptere vilkår & betingelser",
        DE: "Sie müssen die Geschäftsbedingungen akzeptieren",
        NL: "Je moet de voorwaarden accepteren",
        FR: "Vous devez accepter les conditions générales",
        IT: "Devi accettare i termini e condizioni",
        ES: "Debes aceptar los términos y condiciones",
        PT: "Você deve aceitar os termos e condições",
        FI: "Sinun täytyy hyväksyä käyttöehdot",
        SV: "Du måste acceptera användarvillkoren",
        NO: "Du må godta vilkår & betingelser",
    },
    "privacy-policy": {
        EN: "Privacy Policy",
        DA: "Privatlivspolitik",
        DE: "Datenschutzrichtlinie",
        NL: "Privacybeleid",
        FR: "Politique de Confidentialité",
        IT: "Informativa sulla Privacy",
        ES: "Política de Privacidad",
        PT: "Política de Privacidade",
        FI: "Tietosuojakäytäntö",
        SV: "Integritetspolicy",
        NO: "Personvernerklæring",
    },
    "return-policy": {
        EN: "Return Policy",
        DA: "Returbetingelser",
        DE: "Rückgaberichtlinie",
        NL: "Retourbeleid",
        FR: "Politique de Retour",
        IT: "Politica di Reso",
        ES: "Política de Devolución",
        PT: "Política de Devolução",
        FI: "Palautuskäytäntö",
        SV: "Returvillkor",
        NO: "Returvilkår",
    },
    "login.ORDER_ID": {
        EN: "Order ID",
        DA: "Ordre-ID",
        DE: "Bestellnummer",
        NL: "Bestelling-ID",
        FR: "Numéro de Commande",
        IT: "ID Ordine",
        ES: "ID de Pedido",
        PT: "ID do Pedido",
        FI: "Tilausnumero",
        SV: "Order-ID",
        NO: "Ordre-ID",
    },
    "login.ZIP_CODE": {
        EN: "Your Zip Code",
        DA: "Dit postnummer",
        DE: "Ihre Postleitzahl",
        NL: "Je postcode",
        FR: "Votre code postal",
        IT: "Il tuo CAP",
        ES: "Tu código postal",
        PT: "Seu código postal",
        FI: "Postinumerosi",
        SV: "Ditt Postnummer",
        NO: "Postnummeret ditt",
    },
    "login.ORDER_NUMBER": {
        EN: "Order number",
        DA: "Ordrenummer",
        DE: "Bestellnummer",
        NL: "Bestelnummer",
        FR: "Numéro de commande",
        IT: "Numero ordine",
        ES: "Número de pedido",
        PT: "Número do pedido",
        FI: "Tilausnumero",
        SV: "Ordernummer",
        NO: "Ordrenummer",
    },
    "login.required-field": {
        EN: "An order ID is required",
        DA: "Et ordre-ID er påkrævet",
        DE: "Eine Bestellnummer ist erforderlich",
        NL: "Een bestelling-ID is verplicht",
        FR: "Un numéro de commande est requis",
        IT: "È richiesto un ID ordine",
        ES: "Se requiere un ID de pedido",
        PT: "Um ID de pedido é obrigatório",
        FI: "Tilausnumero vaaditaan",
        SV: "Ett order-ID är obligatoriskt",
        NO: "En ordre-ID er obligatorisk",
    },
    "login.email_placeholder": {
        EN: "Email",
        DA: "E-mail",
        DE: "E-Mail",
        NL: "E-mail",
        FR: "E-mail",
        IT: "Email",
        ES: "Correo electrónico",
        PT: "E-mail",
        FI: "Sähköposti",
        SV: "Din mailadress",
        NO: "E-post",
    },
    "login.email_invalid": {
        EN: "Enter in the format name@example.com",
        DA: "Indtast i formatet navn@eksempel.com",
        DE: "Geben Sie im Format name@beispiel.com ein",
        NL: "Voer in het formaat naam@voorbeeld.com in",
        FR: "Entrez au format nom@exemple.com",
        IT: "Inserisci nel formato nome@esempio.com",
        ES: "Ingresa en el formato nombre@ejemplo.com",
        PT: "Digite no formato nome@exemplo.com",
        FI: "Syötä muodossa nimi@esimerkki.com",
        SV: "Ange i formatet namn@exempel.com",
        NO: "Skriv inn i formatet navn@example.com",
    },
    "login.submit_button": {
        EN: "Find your order",
        DA: "Find din ordre",
        DE: "Bestellung finden",
        NL: "Vind je bestelling",
        FR: "Trouver votre commande",
        IT: "Trova il tuo ordine",
        ES: "Encuentra tu pedido",
        PT: "Encontre seu pedido",
        FI: "Etsi tilauksesi",
        SV: "Hitta din order",
        NO: "Finn din ordre",
    },
};
export default texts;
